// Used in device checks
const breakpoints = [
  { name: 'small-min', width: 700 },
  { name: 'small-max', width: 999 },
  { name: 'medium-min', width: 1000 },
  { name: 'tablet-min', width: 1100 },
  { name: 'core-mobile-max', width: 1025 },
  { name: 'core-desktop-min', width: 1025 },
  { name: 'core-tablet-max', width: 1025 },
  { name: 'core-tablet-min', width: 500 }
]

export function narrowerThan(name, width) {
  let list = breakpoints.filter(b => b.width > width)

  return list.some(item => item.name === name)
}

export function widerThan(name, width) {
  let list = breakpoints.filter(b => b.width <= width)

  return list.some(item => item.name === name)
}

export function isCoreMobile() {
  return narrowerThan('core-mobile-max', window.innerWidth)
}

export function isCoreDesktop() {
  return widerThan('core-desktop-min', window.innerWidth)
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/config/breakpoints.js